jQuery(document).ready(function ($) {
    'use strict';

    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        return;
    }

    var blocs = document.querySelectorAll('.bloc_texte_en_avant');

    if (!blocs.length) {
        return;
    }

    var MOINS_DE_MOUVEMENT = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var DUREE = MOINS_DE_MOUVEMENT ? 0 : .8;
    var DECALAGE = MOINS_DE_MOUVEMENT ? 0 : .08;
    var EASE = 'power2.inOut';

    var DEBUT = 'top 25%';

    // la vraie valeur se regle dans texte_en_avant.scss
    var COURSE_DEFAUT = 145;

    function lireCourse(bloc) {
        var valeur = parseFloat(getComputedStyle(bloc).getPropertyValue('--masque-course'));

        return isNaN(valeur) ? COURSE_DEFAUT : valeur;
    }

    Array.prototype.forEach.call(blocs, function (bloc) {
        var lignes = bloc.querySelectorAll('.lignes .ligne');

        if (!lignes.length) {
            return;
        }

        var avant = bloc.querySelectorAll('.lignes .ligne .avant');
        var apres = bloc.querySelectorAll('.lignes .ligne .apres');
        var course = lireCourse(bloc);

        // y: 0 obligatoire : le translate pose en CSS est lu comme un y
        // en px et s'additionnerait au yPercent, le rose ne reviendrait pas
        gsap.set(avant, {y: 0, yPercent: 0});
        gsap.set(apres, {y: 0, yPercent: course});

        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: bloc,
                start: DEBUT,
                toggleActions: 'play none none reverse'
            }
        });

        tl.to(avant, {
            yPercent: -course,
            duration: DUREE,
            stagger: DECALAGE,
            ease: EASE
        }, 0);

        tl.to(apres, {
            yPercent: 0,
            duration: DUREE,
            stagger: DECALAGE,
            ease: EASE
        }, 0);
    });
});
